module.exports = __webpack_public_path__ + "img/backgroundImg.ec31f70c.png";